import { useEffect, useMemo, useRef, useState } from "react";
import React from "react";
import { isEqual } from "lodash";
import './print-image.scss';
import '../../../../ui/loading/loading-popup.scss';
import { ApiImagesGetOne, ImagesGetResponse } from "../../../../../api/front/images/api-images";
import { useAppDispatch } from "../../../../../app/hooks";
import { apiActions } from "../../../../../slices/api-slice";
import { PrintImagesDataEntity } from "../../../../../api/sift/front/api-print-image";

type Props = {
  imgData: PrintImagesDataEntity,
  kijshopCd: string,
}

export const PrintImage = React.memo((props: Props) => {
  const {
    imgData,
    kijshopCd,
  } = props;
  const dispatch = useAppDispatch();
  const [src, setSrc] = useState('');
  const init = useRef<boolean>(false);
  const cnt = useRef<HTMLDivElement>(null);
  
  const splitName = useMemo(() => {
    const { orgFilename: name } = imgData;
    const split = name.split('.');
    const [extension] = split.splice(split.length - 1, 1);
    const fileName = split.join('.');
    const last = fileName.slice(-4, fileName.length);
    const top = fileName.slice(0, fileName.length - 4);
    return {
      top,
      last: `${last}${extension ? `.${extension}` : ''}`
    }
  }, [imgData]);


  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((v) => {
        if (v.isIntersecting && !init.current) {
          init.current = true;
          dispatch(apiActions.run(new ApiImagesGetOne({
            kijshopCd,
            path: `${imgData.pathThumb}/${imgData.filename}`,
          }), {
            onSuccess: (res: Blob) => {
              const url = URL.createObjectURL(res);
              setSrc(url);
            },
          }));
        }
      });
    });
    if (cnt.current) {
      observer.observe(cnt.current);
    }

    return () => {
      observer.disconnect();
      init.current = false;
      setSrc('');
      if (src) {
        URL.revokeObjectURL(src);
      }
    };

  }, [props]);
  
  return (
    <div ref={cnt}>
      <div className="print-preparation-image" style={{ height: src ? undefined : '140px' }}>
        { src ? (
          <img src={src} alt="" />
        ) : (
          <div
            className="loading_popup__dots"
            style={{ fontSize: '0.5rem', animationDuration: `${1}s`, WebkitAnimationDuration: `${1}s` }}
          />
        ) }
      </div>
      <div
        title={imgData.orgFilename}
        className="print-preparation-image__label"
      >
        <div className="print-preparation-image__label__top">{splitName.top}</div>
        <div className="print-preparation-image__label__last">{splitName.last}</div>
      </div>
    </div>
  )
}, (props, nextProps) => {
  return isEqual(props, nextProps) && isEqual(props.imgData, nextProps.imgData);
});